import { Box, Grid, Paper, useTheme } from "@mui/material";
import { gridClasses, GridColDef } from "@mui/x-data-grid";
import { FC, useMemo } from "react";
import { Link, Outlet } from "react-router-dom";
import { Permissions, Tenant } from "../../api/dtos";
import GridActions from "../../components/GridActions";
import SetLinks from "../../components/layout/SetLinks";
import { StyledButton } from "../../components/StyledButton";
import CollapsibleTablePremium from "../../components/tables/CollapsibleTablePremium";
import { createCustomToolbarProps } from "../../components/utility/CustomToolbarProps";
import { DefaultProjectCreateLink } from "../../contexts/layouts/LinkContext";
import TenantsContext from "../../contexts/TenantsContext";
import useTenants from "../../hooks/data/useTenants";

const useTenantColumns = () => {

    const tenantColumns = useMemo(() => {
        const columns: GridColDef<Tenant>[] =  [
            {
                field: "name",
                headerName: "Name",
                flex: 1
            },
            {
                field: "rank",
                headerName: "Rank",
                flex: 1
            },
            {
                field: "actions",
                headerName: '',
                renderCell: (params) => {
                    return (
                        <GridActions
                            editPermission={Permissions.AdminAccess}
                            editUrl={`/admin/stage-precincts/edit/${params.row.id}`}
                        />
                    )
                },
                disableExport: true
            }
        ];

        return columns;
    }, []);

    return tenantColumns;
}


const Agents:FC = () => {

    const columns = useTenantColumns();

    const theme = useTheme();

    const context = useTenants();
    
    const {data: tenants, loading: tenantsLoading} = context;

    const customToolbarProps = useMemo(() => createCustomToolbarProps({
        fileName: `Tenants`,
        exportTitle: `Tenants`,
        includeDateTime: true
    }), []);
    
    return (
        <TenantsContext.Provider value={context}>
            <Outlet />
            <SetLinks
                createProjectLink={DefaultProjectCreateLink}
                stageLinkEnabled={false}
                lotLinkEnabled={false}
            />
            <Grid
                container
                gap={theme.spacing(2)}
                justifyContent={"end"}
                marginBottom={theme.spacing(2)}
            >
                <StyledButton 
                    variant="contained"
                    //@ts-expect-error
                    component={Link}
                    to={`/admin/tenants/create`}
                    state={{
                        back: true
                    }}
                >
                    Add Tenant
                </StyledButton>
            </Grid>
            <Paper>
                <Box
                    sx={{
                        [`& .${gridClasses.root}`]: {
                            
                            [`& .${gridClasses.columnHeader}`]: {
                                height: 'auto !important',
                                minHeight: 56,
                                
                                [`& .${gridClasses.columnHeaderTitleContainer}`]: {
                                    whiteSpace: 'normal',
                                    
                                    [`& .${gridClasses.columnHeaderTitle}`]: {
                                        whiteSpace: 'normal',
                                        paddingTop: theme.spacing(1.5),
                                        paddingBottom: theme.spacing(1.5) 
                                    }
                                },
                                
                                [`& .${gridClasses.iconButtonContainer}`]: {
                                    width: 'unset',
                                },
                                
                                '&.column-group-header': {
                                    backgroundColor: theme.palette.grey[300],
                                    boxShadow: "1",
                                    textAlign: 'center'
                                }
                            }
                        },
                    }}
                    >
                    <CollapsibleTablePremium
                        density="compact"
                        startCollapsed={false} 
                        title={"Tenants"} 
                        loading={tenantsLoading} 
                        columns={columns}
                        rows={tenants}
                        disableColumnMenu={false}
                        disableColumnFilter={false}
                        {...customToolbarProps}
                    />
                </Box>
            </Paper>
        </TenantsContext.Provider>
    );
}

export default Agents;